module.exports = __webpack_public_path__ + "20250721160708/img/no-data.f984596f.png";